export default __webpack_public_path__ + "static/media/game_starter.a5be1eb0.mp3";